export default __webpack_public_path__ + "static/media/backgroundImage.375919c0.png";